import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { useApp } from "@/contexts/AppContext";

export function useFavorites() {
  const { user } = useApp();
  const [favorites, setFavorites] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setFavorites([]); return; }
    supabase
      .from("favorites")
      .select("listing_id")
      .eq("user_id", user.id)
      .then(({ data }) => {
        if (data) setFavorites(data.map((f) => f.listing_id));
      });
  }, [user?.id]);

  async function toggleFavorite(listingId: string) {
    if (!user) return;
    const isFav = favorites.includes(listingId);
    if (isFav) {
      setFavorites((prev) => prev.filter((id) => id !== listingId));
      await supabase.from("favorites").delete().eq("user_id", user.id).eq("listing_id", listingId);
    } else {
      setFavorites((prev) => [...prev, listingId]);
      await supabase.from("favorites").insert({ user_id: user.id, listing_id: listingId });
    }
  }

  return { favorites, toggleFavorite, loading };
}
